import { Component, ElementRef, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AppService } from 'src/app/services/app/app.service';
// import { faXmark } from '@fortawesome/free-solid-svg-icons';
import { AdminService } from 'src/app/services/admin/admin.service';
import { ProductsService } from 'src/app/services/products/products.service';
import { CommonModule } from '@angular/common';
@Component({
  selector: 'app-app-upload-img',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './app-upload-img.component.html',
  styleUrl: './app-upload-img.component.css'
})
export class AppUploadImgComponent {
  @Output() imageSelected = new EventEmitter<File | null>();
  @Output() productIdGenerated = new EventEmitter<any>(); // ახალი productId-ს ემისია
  @Input() appId = 0;
  @Input() imgUrl = ''
  @Input() load = false
  @Input() productId = ''
  @Input() showImg = false
  @Input() isOpen = false
  @Input() edit = false

  @ViewChild('image') images!: ElementRef;
  isDragging = false;
  startX = 0;
  startY = 0;
  translateX = 0;
  translateY = 0;
  scale = 1; // მასშტაბირების შემთხვევაში, თუ გჭირდებათ

  onMouseDown(event: MouseEvent) {
    this.isDragging = true;
    this.startX = event.clientX - this.translateX;
    this.startY = event.clientY - this.translateY;
    event.preventDefault();
  }

  onMouseMove(event: MouseEvent) {
    if (this.isDragging) {
      this.translateX = event.clientX - this.startX;
      this.translateY = event.clientY - this.startY;
      this.images.nativeElement.style.transform = `translate(${this.translateX}px, ${this.translateY}px)`;
    }
  }

  onMouseUp() {
    this.isDragging = false;
  }
  saveImagePosition() {
    const positionData = {
      x: this.translateX,
      y: this.translateY,
      scale: this.scale
    };

    // შეგიძლიათ შეინახოთ მონაცემთა ბაზაში ან სხვა ადგილას
    console.log('Saved position:', positionData);
  }

  loadImagePosition(savedData: { x: number; y: number; scale: number }) {
    this.translateX = savedData.x;
    this.translateY = savedData.y;
    this.scale = savedData.scale;
  
    // გამოიყენეთ სტილი სურათის დასამაგრებლად
    this.images.nativeElement.style.transform = `translate(${this.translateX}px, ${this.translateY}px) scale(${this.scale})`;
  }



  faXmark = 'faXmark'
error:  any
  image: File | null = null;
  imageSrc: string | ArrayBuffer | null = null;
  constructor(
    private ProductsService: ProductsService,
    private adminService: AdminService
  ) { }

  onDragOver(event: DragEvent) {
    event.preventDefault();
    event.stopPropagation();
  }

  onDragLeave(event: DragEvent) {
    event.preventDefault();
    event.stopPropagation();
  }

  onDrop(event: DragEvent) {
    event.preventDefault();
    event.stopPropagation();

    if (event.dataTransfer?.files.length > 0) {
      const file = event.dataTransfer.files[0];
      this.selectImage(file);
    }
  }

  onFileChange(event: Event) {
    const input = event.target as HTMLInputElement;
    if (input.files && input.files.length > 0) {
      const file = input.files[0];
      this.selectImage(file);
    }
  }

  onDragDropClick() {
    
    const fileInput = document.getElementById('image') as HTMLInputElement;
    fileInput.click();
  }

  selectImage(file: File) {
    const allowedTypes = ['image/jpeg', 'image/png', 'image/jpg'];

    if (!allowedTypes.includes(file.type)) {
      this.error = 'სურათი უნდა იყოს JPG, JPEG ან PNG ფორმატში';
      console.error('Invalid image type:', {
        name: file.name,
        type: file.type,
        size: file.size
      });
      this.clearImage();
      return;
    }

    this.image = file;
    this.previewImage(file);
    this.uploadImage(file); // upload the image immediately
  }

  previewImage(file: File) {
    const reader = new FileReader();
    reader.onload = () => {
      this.imageSrc = reader.result;
    };
    reader.readAsDataURL(file);
  }

  clearImage() {
    this.image = null;
    this.imageSrc = null;
    this.imageSelected.emit(null);
  }

  uploadImage(file: File) {
    console.log('Selected upload file:', {
      name: file.name,
      type: file.type,
      size: file.size
    });
    const userId = this.adminService?.user?.id;

    if (!this.appId || !userId) {
      this.error = 'appId ან userId ვერ მოიძებნა';
      console.error('Upload blocked: missing required data', {
        appId: this.appId,
        userId,
        productId: this.productId
      });
      this.clearImage();
      return;
    }

    this.load = true;

    const data = {
      appId: String(this.appId),
      userId: String(userId),
      productId: this.productId ? String(this.productId) : ''
    };

    console.log('Upload product image data:', data);

    this.ProductsService.upload(file, data).subscribe(
      (response: any) => {
        this.load = false;
        console.log('Upload successful', response);

        if (response?.productId) {
          this.productId = String(response.productId);
          this.productIdGenerated.emit(response);
        }
      },
      (error: any) => {
        this.error = error;
        this.load = false;
        console.error('Upload error', error);
        this.clearImage();
      }
    );
  }
}

